import { DSRLoanWaiverService } from '@/modules/global-settings/loan-origination/services/security-policies/dsr-waiver.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
const dsrLoanWaiverService = new DSRLoanWaiverService();
export const state = {
  dsrLoanWaiverSettings: []
};
export const mutations = {
  ...make.mutations(state)
};
export const actions = {
  // Get all waivers
  getDSRLoanWaiverSettings: async ({ commit }) => {
    try {
      const { data } = await dsrLoanWaiverService.getDSRLoanWaiverSettings();
      commit('SET_DSR_LOAN_WAIVER_SETTINGS', data);
      return data;
    } catch (error) {
      Logger.error('getting dsr loan waiver settings', error);
      throw error;
    }
  },
  // Create a new waiver
  createDSRLoanWaiverSetting: async ({ dispatch }, payload) => {
    try {
      const { data } = await dsrLoanWaiverService.createDSRLoanWaiverSetting(
        payload
      );
      dispatch('getDSRLoanWaiverSettings');
      return data;
    } catch (error) {
      Logger.error('creating dsr loan waiver settings', error);
      throw error;
    }
  },
  // Update waiver
  updateDSRLoanWaiverSetting: async ({ dispatch }, payload) => {
    try {
      await dsrLoanWaiverService.updateDSRLoanWaiverSetting(payload);
      dispatch('getDSRLoanWaiverSettings');
    } catch (error) {
      Logger.error('updating dsr loan waiver settings', error);
      throw error;
    }
  }
};
export const getters = make.getters(state);
